export * from './forgotPasswordForm';

export const ForgotPassword = {
  SuccessTextContainer: 'success-text-container',
  ErrorTextContainer: 'error-text-container',
};
